export default function ComparisonHero() {
  return (
    <section className="relative min-h-[520px] md:min-h-[580px] flex items-center overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/0ca6b7bfb6123b481eca76932de6be67.jpg"
        alt="Solar vs Gas vs Whole Home Backup Power Systems Comparison"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-gray-950/92 via-gray-900/75 to-gray-900/30" />

      <div className="relative max-w-6xl mx-auto px-4 md:px-6 py-24 w-full">
        <div className="max-w-3xl">
          <div className="flex flex-wrap items-center gap-2 mb-5">
            <span className="bg-amber-500/20 text-amber-400 text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full">
              Buyer&apos;s Guide
            </span>
            <span className="text-gray-400 text-xs">Updated 2024</span>
          </div>

          <h1 className="text-4xl md:text-5xl font-extrabold text-white leading-tight mb-5">
            Solar vs Gas vs Whole Home<br className="hidden md:block" />
            <span className="text-amber-400"> Backup Power Systems</span>
          </h1>

          <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-8 max-w-2xl">
            The definitive comparison for homeowners who are serious about staying powered during outages.
            We break down costs, capabilities, real-world use cases, and which system actually fits your life.
          </p>

          {/* Quick-jump anchors */}
          <div className="flex flex-wrap gap-2">
            {[
              { label: "Full Comparison Table", href: "#comparison-table" },
              { label: "Solar Deep Dive", href: "#solar" },
              { label: "Gas Deep Dive", href: "#gas" },
              { label: "Whole Home Deep Dive", href: "#whole-home" },
              { label: "Cost Breakdown", href: "#cost" },
              { label: "Which Is Right for Me?", href: "#use-case" },
            ].map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-xs font-semibold text-gray-300 hover:text-amber-400 border border-gray-600 hover:border-amber-500 px-3 py-1.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
